import React from 'react';
import { SocialLoginProvider } from '../types';
import SocialButtonBase from '../SocialButtonBase';
const SocialButtonTest = ({ className, redirectToJoin = false, attemptSocialLogin })=>{
    return /*#__PURE__*/ React.createElement(SocialButtonBase, {
        className: className,
        onClick: (e)=>{
            e.preventDefault();
            attemptSocialLogin({
                provider: SocialLoginProvider.Test,
                token: `123-${Math.random()}`,
                redirectToJoin
            });
        }
    }, "Test social button");
};
SocialButtonTest.displayName = 'SocialButtonTest';
export default SocialButtonTest;

//# sourceMappingURL=SocialButtonTest.js.map